
import React, { useContext } from "react";
import { ThemeContext } from "providers/ThemeProvider";
import { Header } from "components/theme";
import { Container } from "components/common";
import {
  Wrapper, IntroWrapper, Details, HeroContainer,
  AbsoluteImage
} from "./styles";
// import FadeInRight from "hooks/fadeInRight";
// import FadeInLeft from "hooks/fadeInLeft";
import useMedia from "hooks/useMedia";
import JogsiKell from "./JogsiKell";
import Jelentkezz from "./Jelentkezz"
import WhatsApp from "./WhatsApp"
import IntroContact from "./IntroContact"
import HeroImage from "./HeroImg"
import HeroImageMob from "./HeroImgMob"



export const Intro = () => {

  const { theme } = useContext(ThemeContext);

  const isDesktop = useMedia('(min-width: 960px)');
  return (
    <>
      {isDesktop ?
      <>
          <Header />
        <Wrapper style={{textAlign:'center', padding: '4rem 0 0 0'}}>
          <IntroWrapper as={ HeroContainer}>
            <Details theme={theme} as={AbsoluteImage}>
              {/* <FadeInRight> */}
                <JogsiKell style={{ color: '#fff', paddingLeft:'2rem' }} />
                <Jelentkezz style={{ color: '#fff', paddingLeft:'2rem'}} />
              {/* </FadeInRight> */}
              {/* <FadeInLeft> */}
                <WhatsApp />
              {/* </FadeInLeft> */}
            </Details>
            <HeroImage />
          </IntroWrapper>
              {/* <FadeInLeft> */}
            <IntroContact />
            {/* </FadeInLeft> */} 
        </Wrapper>
      </>
        :
        <>
          <Header />
          <IntroWrapper as={Container} style={{ padding: '4rem 0 0 0'}}>
            <Details theme={theme}></Details>
              <JogsiKell />
            {/* <FadeInLeft> */}
            <IntroContact />
            {/* </FadeInLeft> */} 
            <HeroImageMob />
            {/* <FadeInRight> */}
              <Jelentkezz />
            {/* </FadeInRight> */}
            {/* <FadeInLeft> */}
                <WhatsApp />
              {/* </FadeInLeft> */}
          </IntroWrapper>
        </>
      }
    </>
  );
};